var render = function render(){var _vm=this,_c=_vm._self._c;return _c('Table',{attrs:{"columns":_vm.columns,"data":_vm.list},scopedSlots:_vm._u([{key:"action",fn:function({ row }){return [_c('a',{on:{"click":function($event){return _vm.$emit('update', row)}}},[_vm._v(_vm._s(_vm.$t('name.update')))])]}}])})
}
var staticRenderFns = []

export { render, staticRenderFns }